import { paroApi } from '../httpService';


const getGroups = async (query: any) => {
    try {
        const result = await paroApi.get('groups', {
            params: query
        });

        return {
            success: true,
            data: result.data.data,
            pager: result.data.pager
        };
    } catch (error: any) {
        return {
            success: false,
            message: "An unexpected Error"
        };
    }
}


export default {
    getGroups,
}